export default __webpack_public_path__ + "static/media/Thug's Bracers of the Hidden Tomb.7a1944d4.jpg";